<script lang="ts" setup>

interface Props {
    height?: number;
    width?: number;
    cycle?: boolean;
}

defineProps<Props>();

defineOptions({
    inheritAttrs: false
});

</script>

<template>
  <div :style="[width ? { width: width + 'px' } : undefined, height ? { height: height + 'px' } : undefined]"
       :class="['skeleton', { 'skeleton--cycle': cycle }]"
       v-bind="$attrs"
  ></div>
</template>

<style lang="scss" scoped>

.skeleton {
  position: relative;
  overflow: hidden;
  animation: gradient-loading 1.5s infinite linear;
  background: linear-gradient(90deg, var(--layer-floor-1) 25%, var(--layer-floor-0) 50%, var(--layer-floor-1) 75%);
  background-size: 200% 100%;

  &--cycle {
    border-radius: 50%;
  }
}

@keyframes gradient-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>
